import { useReduxState } from 'hooks';
import { useApiData } from 'lib/api';
import { Button, ContentLabel } from 'components/common';
import { Select } from 'components/common/form';
import {
  HomePageSettingsModulesModuleFooter,
  HomePageSettingsModulesModuleUpdateSettings,
  HomePageSettingsTilesCourses
} from '.';

import type { GetCategoriesRes } from 'shared-types/responses';
import type { ModuleInSettings } from './HomePageSettingsModules';

interface Props {
  module: ModuleInSettings;
  updateModule: (module: ModuleInSettings) => void;
}

const HomePageSettingsModulesModuleCoursesCategory = ({
  module,
  updateModule
}: Props) => {
  const { messages } = useReduxState();

  const { data } = useApiData<GetCategoriesRes>({
    url: '/admin/categories-courses'
  });

  const handleSyncTitle = (title: string) => {
    const modifiedModule = { ...module, title };
    updateModule(modifiedModule);
  };

  const selectedCategory = data?.categories.find(
    (category) => category.id === module.categories?.[0]
  );

  const url = selectedCategory
    ? `/admin/courses?courseType=all&page=1&sortBy=alphabetical` +
      `&limit=${module.limit}` +
      `&categoryId=${selectedCategory.id}`
    : '';

  return (
    <div>
      <HomePageSettingsTilesCourses module={module} url={url} />

      <HomePageSettingsModulesModuleFooter
        items={[
          {
            label: messages.commonCategory,
            value: selectedCategory ? (
              <>
                {selectedCategory?.title}
                <Button
                  category="light"
                  size="small"
                  onClick={() => handleSyncTitle(selectedCategory?.title)}
                  style={{ bottom: 1, marginLeft: 10, padding: '3px 7px 4px' }}
                  text={`${messages.homePageModuleCoursesCategorySyncTitle}`}
                />
              </>
            ) : (
              <div className="placeholder">
                {messages.homePageModuleCoursesCategoryPlaceholder}
              </div>
            )
          },
          {
            label: messages.homePageSettingsModulesNumberOfCourses,
            value: `${messages.homePageSettingsModulesLimitMax} ${module.limit}`
          }
        ]}
      >
        <HomePageSettingsModulesModuleUpdateSettings
          childrenInitialValues={{
            categories: [selectedCategory?.id]
          }}
          module={module}
          onUpdate={updateModule}
          productType="course"
        >
          <ContentLabel horizontal={true} label={messages.commonCategory}>
            <Select
              field="categories[0]"
              isSearchable={true}
              options={data?.categories.map((category: any) => ({
                label: category.title,
                value: category.id
              }))}
              placeholder={messages.homePageModuleCoursesCategoryPlaceholder}
              style={{ flexGrow: 1 }}
            />
          </ContentLabel>
        </HomePageSettingsModulesModuleUpdateSettings>
      </HomePageSettingsModulesModuleFooter>
    </div>
  );
};

export default HomePageSettingsModulesModuleCoursesCategory;
